// 企业公告
<template>
  <div style="height:100%">
    <el-card class="announce-wrap">
      <div slot="header">
        <span class="fontSize_18 fontWeight_bold">企业公告</span>
        <el-button
          type="primary"
          plain
          size="mini"
          class="ml-20"
          icon="el-icon-plus"
          @click="handleEdit('add')"
          >发布公告</el-button
        >
      </div>
      <div class="announce-contain" ref="announceScroll">
        <el-timeline>
          <el-timeline-item
            v-for="(item, index) in noticeInfoArr"
            :key="index"
            :timestamp="item.timestamp"
            icon="el-icon-s-promotion"
            placement="top"
            color="#409EFF"
            size="large"
          >
            <el-card class="list-items">
              <div>
                <p
                  class="notice-title fontSize_16 mb-10 pointer"
                  @click="handleLookOver(item)"
                >
                  <el-tag size="mini mr-10">{{ item.type_label }}</el-tag>
                  {{ item.title }}
                </p>
                <p class="fontColor_info">
                  {{ item.update_user_name }} 发布于 {{ item.update_time }}
                </p>
              </div>
              <div class="operate-box">
                <div class="mb-10">
                  <el-button
                    type="primary"
                    plain
                    size="mini"
                    icon="el-icon-edit"
                    @click="handleEdit('edit', item)"
                    >重新编辑</el-button
                  >
                </div>
                <div>
                  <el-button
                    type="danger"
                    plain
                    size="mini"
                    icon="el-icon-delete"
                    @click="handleRemove(item)"
                    >移除公告</el-button
                  >
                </div>
              </div>
              <!-- <span class="page-tag">Page {{ parseInt(index / 10 + 1) }}</span> -->
            </el-card>
          </el-timeline-item>
        </el-timeline>
      </div>
    </el-card>
    <!-- 公告预览 -->
    <NoticePreview
      :previewSign="previewSign"
      :previewData="previewData"
    ></NoticePreview>
    <!-- 公告编辑 -->
    <el-dialog
      :visible.sync="editVis"
      width="70%"
      top="5vh"
      :before-close="
        (done) => {
          $confirm('编辑内容并不会保存，确认关闭吗？')
            .then((_) => {
              done();
            })
            .catch((_) => {});
        }
      "
    >
      <div class="header-ope mb-15">
        <div>
          <p class="fontSize_16">公告类型</p>
          <el-select v-model="formData.type" class="s-input">
            <el-option
              v-for="item in noticeTypeOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </div>
        <div>
          <p class="fontSize_16">公告标题</p>
          <el-input v-model="formData.title" class="s-input"></el-input>
        </div>
      </div>
      <div class="editor-wrap">
        <Toolbar
          :editor="config.editor"
          :defaultConfig="config.toolbarConfig"
          :mode="config.mode"
          class="editor-toolbar"
        />
        <Editor
          style="height: 500px; overflow-y: hidden;"
          v-model="formData.notice_text"
          :defaultConfig="config.editorConfig"
          :mode="config.mode"
          @onCreated="onCreated"
        />
      </div>
      <div slot="footer">
        <el-button size="mini" @click="editVis = false" :loading="btnLoading"
          >取消</el-button
        >
        <el-button
          size="mini"
          type="success"
          @click="handleAnnounce"
          :loading="btnLoading"
        >
          保存并发布
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { Editor, Toolbar } from "@wangeditor/editor-for-vue";
import { DomEditor } from "@wangeditor/editor";
export default {
  components: {
    NoticePreview: () => import("./components/noticePreviewComp.vue"),
    Editor,
    Toolbar,
  },
  data() {
    return {
      noticeInfoArr: [],
      previewData: {},
      previewSign: 0, // 公告组件开启标识
      editVis: false,
      noticeTitle: "",
      config: {
        editor: null,
        html: "",
        toolbarConfig: {
          // 剔除以下工具栏
          excludeKeys: [
            "group-video",
            "code",
            "sup",
            "sub",
            "todo",
            "insertTable",
            "codeBlock",
            "fullScreen",
          ],
        },
        editorConfig: {
          placeholder: "请输入公告内容...",
          MENU_CONF: {
            uploadImage: {
              server: this.$store.state.uploadUrl,
              maxFileSize: 1 * 1024 * 1024, // 1M
              base64LimitSize: 5 * 1024, // 5kb 小于该值就插入 base64 格式，而不上传
              fieldName: "file",
              allowedFileTypes: ["image/*"],
              base64: true,
              customInsert(res, insertFn) {
                insertFn(res.data);
              },
            },
          },
          mode: "default",
        },
      },
      formData: {
        type: "", // 公告类型 0-一般公告 1-紧急公告 2-系统更新公告
        title: "", // 公告标题
        notice_text: "", // 公告内容
        // notice_push_start: '' ,// 公告推送开始时间
        // notice_push_end: '', // 公告推送结束时间
      },

      operateType: "",
      btnLoading: false,
      // 懒加载
      currentPage: 1,
      loadOver: false, // 加载完成 最后一页
    };
  },
  computed: {
    noticeTypeOptions() {
      return this.$store.state.commonOptions.noticeTypeOptions;
    },
  },
  methods: {
    lazyLoadSet() {
      this.$refs.announceScroll.addEventListener("scroll", this.scrollHandler);
    },
    lazyLoadRemove() {
      this.$refs.announceScroll.removeEventListener(
        "scroll",
        this.scrollHandler
      );
    },
    scrollHandler() {
      let dom = this.$refs.announceScroll;
      const scrollDistance =
        dom.scrollHeight - dom.scrollTop - dom.clientHeight;
      if (scrollDistance <= 160 && !this.loadOver) {
        this.currentPage++;
        this.getNotice();
      }
    },
    onCreated(editor) {
      this.config.editor = Object.seal(editor);
      this.$nextTick(() => {
        const toolbar = DomEditor.getToolbar(editor);
        const curToolbarConfig = toolbar.getConfig();
      });
    },
    handleLookOver(row) {
      this.previewData = row;
      this.previewSign++;
    },
    // 编辑公告
    handleEdit(type, row) {
      this.formData = {
        type: "", // 公告类型 0-一般公告 1-紧急公告 2-系统更新公告
        title: "", // 公告标题
        notice_text: "", // 公告内容
      };
      this.operateType = type;
      if (type == "edit") {
        Object.keys(this.formData).forEach((key) => {
          this.formData[key] = row[key];
        });
        this.formData.id = row.id;
      }
      this.editVis = true;
    },

    // 发布公告
    handleAnnounce() {
      let apiName = "";
      let paramObj = {
        ...this.formData,
      };
      if (this.operateType == "edit") {
        apiName = "modifyEnterpriseNoticeApi";
        paramObj.update_user = this.$store.state.userId;
      } else {
        apiName = "addEnterpriseNoticeApi";
        paramObj.create_user = this.$store.state.userId;
        paramObj.update_user = this.$store.state.userId;
      }
      this.btnLoading = true;
      this.$api[apiName](paramObj)
        .then((res) => {
          if (res.data.code === 0) {
            this.$notify.success({
              title: "消息",
              message: "公告已发布",
              showClose: false,
            });
            this.getNotice("update");
            this.editVis = false;
          }
        })
        .catch((err) => {
          console.log(err);
          this.$message.error("发布失败");
        })
        .finally(() => {
          this.btnLoading = false;
        });
    },
    // sign 有内容时，清空列表
    getNotice(sign = null) {
      let paramObj = {
        page_now: this.currentPage,
        page_size: 10,
      };
      if (sign === "update") {
        this.noticeInfoArr = [];
        paramObj.page_now = 1;
        this.currentPage = 1;
      } else if (sign === "delete") {
        this.noticeInfoArr = [];
        paramObj.page_size = this.currentPage * paramObj.page_size;
        paramObj.page_now = 1;
        // this.currentPage = 1;
      }

      const loading = this.$loading({
        lock: true,
        target: ".announce-wrap",
      });
      this.$nextTick(() => {
        this.lazyLoadRemove();
      });
      this.$api
        .getEnterpriseNoticeApi(paramObj)
        .then((res) => {
          // console.log(res);
          if (res.data.code === 0) {
            this.noticeInfoArr = [
              ...this.noticeInfoArr,
              ...res.data.data.list.map((item) => {
                item.update_user_name = this.$tools.conversionName(
                  item.update_user
                );
                item.type_label = this.noticeTypeOptions.filter(
                  (ty) => ty.value == item.type
                )[0].label;
                return item;
              }),
            ];
            this.loadOver = res.data.data.list.length < 10;
            this.$nextTick(() => {
              this.lazyLoadSet();
            });
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          loading.close();
        });
    },

    // 移除公告
    handleRemove(row) {
      this.$confirm("此操作将永久删除该公告, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$api.deleteEnterpriseNoticeApi({ id: row.id }).then((res) => {
            this.$notify.success({
              title: "消息",
              message: "已删除",
              showClose: false,
            });
            this.getNotice("delete");
          });
        })
        .catch((err) => {
          console.log("==============", err);
          this.$message.error("删除失败");
        });
    },
  },
  mounted() {
    this.getNotice();
  },
  beforeDestroy() {
    const editor = this.config.editor;
    if (editor == null) return;
    editor.destroy(); // 销毁编辑器
  },
};
</script>
<style src="@wangeditor/editor/dist/css/style.css"></style>
<style lang="scss" scoped>
.announce-wrap {
  height: 100%;
  overflow: hidden;
  // display: flex;
  // flex-direction: column;
  ::v-deep > .el-card__body {
    padding: 0;
    // flex: 1;
    height: calc(100% - 67px);
  }
}
.announce-contain {
  padding: 20px 80px 0;
  height: 100%;
  overflow-y: auto;
  ::v-deep .el-timeline-item__node {
    left: -4px;
    width: 20px;
    height: 20px;
  }
  .list-items {
    position: relative;
    .notice-title {
      width: fit-content;
      max-width: 50%;
      &:hover {
        color: #409eff;
      }
    }

    .operate-box {
      position: absolute;
      right: 60px;
      top: 10px;
      display: none;
    }
    &:hover {
      .operate-box {
        display: block;
      }
    }
  }
}

.editor-wrap {
  border: 1px solid #ccc;
  .editor-toolbar {
    font-size: 20px;
    border-bottom: 1px solid #ccc;
    // ::v-deep .w-e-panel-content-emotion {
    //   > li {
    //     font-size: inherit;
    //   }
    // }
    // ::v-deep .w-e-select-list {
    //   span {
    //     // 覆盖默认字体样式
    //     font-size: inherit;
    //   }
    // }
  }
}

.header-ope {
  height: 50px;
  > div {
    float: left;
    width: 50%;
    display: flex;
    align-items: center;
    > p {
      width: 80px;
      text-align: center;
    }
    .s-input {
      width: 50%;
    }
  }
}
</style>
